// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
.text-overflow__hs2kD {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.text-gradient__rWXjZ {
  background-image: -webkit-gradient(linear, 37.219838% 34.532506%, 36.425669% 93.178216%, from(#29cdff), to(#0a60ff), color-stop(0.37, #148eff));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.background-hover__WgF5e {
  transition: all 0.3s ease-out;
}
.background-hover__WgF5e:hover {
  background-color: #f9f9fc;
}
.search__Y3ntf input {
  border: 0px !important;
  background-color: #496C7F;
  height: 30px;
  color: white;
}
.search__Y3ntf .ant-input-affix-wrapper {
  background-color: #496C7F;
  color: white;
  padding-left: 22px;
  border-color: transparent;
  border-radius: 0px;
}
.search__Y3ntf .ant-input-affix-wrapper:hover {
  border-color: transparent;
}
.search__Y3ntf .ant-input-affix-wrapper > input.ant-input {
  padding-left: 5px;
}
.brand__Prw1d {
  z-index: 1;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0px solid;
  padding: 0 24px;
  box-shadow: 0 1px 9px -3px rgba(0, 0, 0, 0.2);
}
.brand__Prw1d .logo__t9adz {
  display: flex;
  align-items: center;
  justify-content: center;
}
.brand__Prw1d .logo__t9adz img {
  width: 160px;
  margin-right: 10px;
}
.sider__XW53z {
  box-shadow: rgba(140, 139, 139, 0.1) 0 0 28px 0;
  z-index: 10;
}
.sider__XW53z {
  height: 100%;
}
.sider__XW53z .ant-layout-sider-children {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.sider__XW53z .ant-menu-sub.ant-menu-inline > .ant-menu-item,
.sider__XW53z .ant-menu-sub.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
  height: 25px;
  line-height: 20px;
}
.sider__XW53z .ant-menu-inline > .ant-menu-item {
  height: 30px;
  line-height: 30px;
}
.sider__XW53z .ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
  height: 30px;
  line-height: 30px;
}
.sider__XW53z .ant-menu-item .ant-menu-item-icon {
  min-width: 17px;
  font-size: 17px;
}
.menuContainer__R_XdF {
  height: calc(100vh - 150px);
}
@keyframes fadeLeftIn__DowAu {
  0% {
    transform: translateX(5px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Sidebar/Sider.module.less","webpack://./src/Themes/mixin.less"],"names":[],"mappings":"AAAA,4FAA4F;AAC5F,6CAA6C;AAC7C,sBAAsB;AACtB,6FAA6F;ACO7F;EACE,mBAAA;EACA,uBAAA;EACA,gBAAA;ADLF;ACQA;EACE,+IAAA;EAQA,6BAAA;EACA,oCAAA;ADbF;ACgBA;EACE,6BAAA;ADdF;ACeE;EACE,yBAAA;ADbJ;AAjBC;EAGI,sBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;AAiBL;AAvBC;EAWM,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AAeP;AA9BC;EAmBM,yBAAA;AAcP;AAjCC;EAuBM,iBAAA;AAaP;AAPC;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,eAAA;EACA,6CAAA;AASH;AAjBC;EAWI,aAAA;EACA,mBAAA;EACA,uBAAA;AASL;AAtBC;EAgBM,YAAA;EACA,kBAAA;AASP;AAFC;EACE,+CAAA;EACA,WAAA;AAIH;AANC;EAKI,YAAA;AAIL;AATC;EAQM,aAAA;EACA,sBAAA;EACA,8BAAA;AAIP;AAdC;;EAeM,YAAA;EACA,iBAAA;AAGP;AAnBC;EAoBM,YAAA;EACA,iBAAA;AAEP;AAvBC;EAyBM,YAAA;EACA,iBAAA;AACP;AA3BC;EA8BM,eAAA;EACA,eAAA;AAAP;AAMC;EAEE,2BAAA;AALH;AA2BC;EACE;IACE,0BAAA;IACA,UAAA;EAzBH;EA4BC;IACE,wBAAA;IACA,UAAA;EA1BH;AACF","sourcesContent":[" @import '../../Themes/vars.less';\n\n .search {\n\n   input {\n     border: 0px !important;\n     background-color: #496C7F;\n     height: 30px;\n     color: white;\n   }\n\n   :global {\n     .ant-input-affix-wrapper {\n       background-color: #496C7F;\n       color: white;\n       padding-left: 22px;\n       border-color: transparent;\n       border-radius: 0px;\n     }\n\n     .ant-input-affix-wrapper:hover {\n       border-color: transparent;\n     }\n\n     .ant-input-affix-wrapper>input.ant-input {\n       padding-left: 5px;\n     }\n\n   }\n }\n\n .brand {\n   z-index: 1;\n   height: 72px;\n   display: flex;\n   align-items: center;\n   justify-content: center;\n   border: 0px solid;\n   padding: 0 24px;\n   box-shadow: 0 1px 9px -3px rgba(0, 0, 0, 0.2);\n\n   .logo {\n     display: flex;\n     align-items: center;\n     justify-content: center;\n\n     img {\n       width: 160px;\n       margin-right: 10px;\n     }\n\n   }\n\n }\n\n .sider {\n   box-shadow: fade(@text-color, 10%) 0 0 28px 0;\n   z-index: 10;\n\n   :global {\n     height: 100%;\n\n     .ant-layout-sider-children {\n       display: flex;\n       flex-direction: column;\n       justify-content: space-between;\n     }\n\n     .ant-menu-sub.ant-menu-inline>.ant-menu-item,\n     .ant-menu-sub.ant-menu-inline>.ant-menu-submenu>.ant-menu-submenu-title {\n       height: 25px;\n       line-height: 20px;\n     }\n\n     .ant-menu-inline>.ant-menu-item {\n       height: 30px;\n       line-height: 30px;\n     }\n\n     .ant-menu-inline>.ant-menu-submenu>.ant-menu-submenu-title {\n       height: 30px;\n       line-height: 30px;\n     }\n\n     .ant-menu-item .ant-menu-item-icon {\n       min-width: 17px;\n       font-size: 17px;\n     }\n\n   }\n }\n\n .menuContainer {\n   // height: ~'calc(100vh - 120px)';\n   height: ~'calc(100vh - 150px)';\n   // overflow-x: hidden; // Abilita la scroll normale\n   // flex: 1;\n   // border: 1px solid;\n\n   // &::-webkit-scrollbar-thumb {\n   //   background-color: transparent;\n   // }\n\n   // &:hover {\n   //   &::-webkit-scrollbar-thumb {\n   //     background-color: rgba(0, 0, 0, 0.2);\n   //   }\n   // }\n\n   // :global {\n   //   .ant-menu-inline { \n   //     border-right: none;\n   //   }\n   // }\n }\n\n @keyframes fadeLeftIn {\n   0% {\n     transform: translateX(5px);\n     opacity: 0;\n   }\n\n   100% {\n     transform: translateX(0);\n     opacity: 1;\n   }\n }","@import './default.less'; \n\n@dark-half: #494949;\n@purple: #d897eb;\n@shadow-1: 4px 4px 20px 0 rgba(0, 0, 0, 0.01);\n@shadow-2: 4px 4px 40px 0 rgba(0, 0, 0, 0.05);\n@transition-ease-in: all 0.3s ease-out;\n@transition-ease-out: all 0.3s ease-out;\n@ease-in: ease-in;\n\n.text-overflow {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.text-gradient {\n  background-image: -webkit-gradient(\n    linear,\n    37.219838% 34.532506%,\n    36.425669% 93.178216%,\n    from(#29cdff),\n    to(#0a60ff),\n    color-stop(0.37, #148eff)\n  );\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.background-hover {\n  transition: @transition-ease-in;\n  &:hover {\n    background-color: @hover-color;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text-overflow": `text-overflow__hs2kD`,
	"text-gradient": `text-gradient__rWXjZ`,
	"background-hover": `background-hover__WgF5e`,
	"search": `search__Y3ntf`,
	"brand": `brand__Prw1d`,
	"logo": `logo__t9adz`,
	"sider": `sider__XW53z`,
	"menuContainer": `menuContainer__R_XdF`,
	"fadeLeftIn": `fadeLeftIn__DowAu`
};
export default ___CSS_LOADER_EXPORT___;
